import {load} from 'recaptcha-v3'
import useCustomConfig from "~/composables/useEnvConfig";

export default defineNuxtPlugin(async () => {
    const config = useCustomConfig();
    useNuxtApp().$recaptcha = await load(config.public.RECAPTCHA_KEY, {
        autoHideBadge: true
    })
});